import * as React from "react";

import { cn } from "@/lib/utils";

function PageTitle({
  className,
  children,
  title,
  ...props
}: React.ComponentProps<"h2"> & { title?: string }) {
  const text =
    title ??
    React.Children.toArray(children)
      .filter((c) => typeof c === "string")
      .join("");

  React.useEffect(() => {
    if (!text) return;
    document.title = `${text} | Rootline Dashboard`;
    return () => {
      document.title = "Rootline Dashboard";
    };
  }, [text]);

  return (
    <h2
      className={cn(
        "min-w-0 max-w-full truncate text-2xl font-medium sm:max-w-none sm:overflow-visible sm:text-clip sm:whitespace-normal",
        className,
      )}
      {...props}
    >
      {children}
    </h2>
  );
}

function PageTitleText({
  className,
  ...props
}: React.ComponentProps<"span">) {
  return (
    <span
      className={cn(
        "min-w-0 truncate sm:overflow-visible sm:text-clip sm:whitespace-normal",
        className,
      )}
      {...props}
    />
  );
}

export { PageTitle, PageTitleText };
